// 1px resting border in the strong border colour, 2px primary on focus.
const outlineStyles = (theme, cls) => ({
  [`& .${cls}`]: {
    borderColor: theme.palette.border.strong,
    borderWidth: "1px",
  },
  [`&:hover .${cls}`]: {
    borderColor: theme.palette.text.tertiary,
  },
  [`&.Mui-focused .${cls}`]: {
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  [`&.Mui-error .${cls}`]: {
    borderColor: theme.palette.error.main,
  },
});

export const MuiOutlinedInput = (mode) => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        // Matches MuiInputLabel's 18px so the notch fits the shrunk label
        notchedOutline: {
          fontSize: "18px",
        },
        // Set here rather than on MuiTextField so a bare <Select> or
        // <OutlinedInput> is rounded like the text fields next to it
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.shape.borderRadius * 3,
          ...outlineStyles(theme, "MuiOutlinedInput-notchedOutline"),
        }),
      },
    },
    // Date/time picker fields render their own input, so the text field
    // styling above and in MuiTextField has to be repeated for them
    MuiPickersOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: "18px",
        },
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.shape.borderRadius * 3,
          ...outlineStyles(theme, "MuiPickersOutlinedInput-notchedOutline"),
        }),
      },
    },
  };
};
